// Canal externo de YouTube con contenido general sobre síntomas frecuentes en
// GLP-1 — nunca un vídeo específico elegido por la app en función de lo que
// el paciente ha escrito, solo un enlace genérico al canal completo. El
// usuario decide qué mirar una vez allí, la app no hace ningún emparejamiento
// síntoma → vídeo.
export const GLP1_YOUTUBE_CHANNEL_URL = null; // TODO: añadir la URL del canal cuando exista

export function openFaqChannel() {
  if (GLP1_YOUTUBE_CHANNEL_URL) {
    window.open(GLP1_YOUTUBE_CHANNEL_URL, '_blank', 'noopener,noreferrer');
  }
}
